 import img1 from '../../images/hotel-booking.png';
 import img2 from '../../images/e-commerce.jpg';
 import img3 from '../../images/local_venue.JPG';
 import img4 from '../../images/weather-finder.JPG';
 import img6 from '../../images/budget.JPG';
 import img7 from '../../images/recipe-app.JPG';
 import img8 from '../../images/dad-jokes-app.JPG';
 import img9 from '../../images/expense.JPG';
 import img12 from '../../images/mobile-store.JPG';
 
 export default [

  {
    "id": 3,
    "name": "Local_venue",
    "description": "This project is made with Javascript and Bootstrap. With this project you can enter a loan value you wish to apply and give a time period for the loan you want and the %age as interest you wish to pay for that time period. then it will show you monthly payment and a total payment and total interest.",
    "code_link": "https://github.com/nagireddy1234/local_venue",
    "deploy_link": "https://nagireddy1234.github.io/local_venue/",
    "tools": ["Reactjs", "JavaScript", "react-animation", "Material-UI"],
    "icons": ["fab", "js-square"],
    "image":img3,
    "image_describe":"local_venue"
  },
  {
    "id": 4,
    "name": "Weather-Finder",
    "description": "This project is made with React Js app. A user can find recipes of differnet food items and his search list can be saved in local storage.",
    "code_link": "https://github.com/nagireddy1234/weather-App",
    "deploy_link": "https://weather-finding-app.netlify.com/?_ga=2.93918740.809865735.1586892963-319421270.1585670224",
    "tools": ["React Js, Local Storage"],
    "icons": ["fab", "react"],
    "image":img4,
    "image_describe":"weather-finder"
  },
 
  {
    "id": 5,
    "name": "Budget Calculator",
    "description": "This is a Budget calculator app and written with react hooks in order to study react framework which you can add and caluclate dialy expenses, remove when its done .",
    "code_link": "https://github.com/nagireddy1234/budget-caluclator/tree/master",
    "deploy_link": "https://nagireddy1234.github.io/budget-caluclator/",
    "tools": ["React Js", "React Hooks", "Local storage"],
    "icons": ["fab", "react"],
    "image": img6,
    "image_describe":"budget-calculator"
  },

  {
    "id": 6,
    "name": "Recipe-App",
    "description": "In this project, I have used Javascript and Bootstrap for making a book list which is stored in your local storage and can be save for next time. You can all delete books at once or edit your book list and keep a new list into storage.",
    "code_link": "https://github.com/nagireddy1234/recipe-app",
    "deploy_link": "https://recipes-ideas-app.netlify.com/?_ga=2.126810500.809865735.1586892963-319421270.1585670224",
    "tools": ["Javascript", "BootStrap"],
    "icons": ["fab", "js-square"],
    "image":img7,
    "image_describe":"recipe-app"
  },
  {
    "id": 7,
    "name": "Dad-Joke-App",
    "description": "Simple JavaScript application that allows a user to make a to-do list and keep it stored in local data storage.",
    "code_link": "https://github.com/nagireddy1234/dad-jokes-app",
    "deploy_link": "https://dadjokes-app.netlify.com/",
    "tools": ["React", "Local storage"],
    "icons": ["fab", "js-square"],
    "image":img8,
    "image_describe":"dad-jokes-app"
  },
  {
    "id": 9,
    "name": "Expense Tracker",
    "description": "In this project, I have made a sass project with the help of sass plugins and gulp task-runner. This project is made to show my sass skills and only is about frontend web design made with flexbox and BEM.",
    "code_link": "https://github.com/nagireddy1234/expenseTracker",
    "deploy_link": "https://github.com/nagireddy1234/expenseTracker",
    "tools": ["Reactjs", "JavaScript"],
    "icons": ["Reactjs", "JavaScript"],
    "image":img9,
    "image_describe":"expenses-tracker"
  },
  {
    "id": 10,
    "name": "E-commerce Project",
    "description": "This is a React app with Redux where users can find any movie of their choice and get information about that movie. The data is taken from an API which reflects IMDB movie data. This app can be enhanced as a cinema website where people can buy their tickets for the movies.",
    "code_link": "https://github.com/nagireddy1234/E-commerce_capstoneProject",
    "deploy_link": "https://ecommerce-mobilestore.netlify.com/",
    "tools": ["React Js", "Redux","local storage" ],
    "icons": ["fab", "react"],
    "image":img2,
    "image_describe":"e-commerce"
  },
  {
    "id": 11,
    "name": "Hotel-Booking-App",
    "description": "This is a Hotel-booking React Js app to book different kinds of rooms whereas different users can remove or add the rooms in their order and if someone can have access to dashboard, he can change the state of rooms on the basis of new rooms or already booked.",
    "code_link": "https://github.com/nagireddy1234/Hotel-Booking-App",
    "deploy_link": "https://hotelbookingapp.netlify.app/",
    "tools": ["React Js", "Firebase"],
    "icons": ["fab", "react"],
    "image":img1,
    "image_describe":"beach resort Image"
  },
  {
    "id": 12,
    "name": "Tech-Store-App",
    "description": "In this project, I have made a sass project with the help of sass plugins and gulp task-runner. This project is made to show my sass skills and only is about frontend web design made with flexbox and BEM.",
    "code_link": "https://github.com/nagireddy1234/mobile-tech-store",
    "deploy_link": "https://mobilesstore.netlify.com/",
    "tools": ["Sass", "Gulp"],
    "icons": ["fab", "sass"],
    "image":img12,
    "image_describe":"tech-store"
  },
 
]
